import { useState, useEffect } from "react";
import "./Stylesheets/Landing.css";
import fish from "./Images/fish.avif";
import twofishes from "./Images/landingpageimg.png";

export default function Landing() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowImage(true), 1000);
    return () => clearTimeout(t); // cleanup
  }, []);

  return (
    <div className="landing-outer-container">
      <div className="landing-container">{/* content */}</div>

 
        <img className={`landing-hero ${showImage&&'showImage'}`}src={twofishes} alt="Fish illustration" />
 s
    </div>
  );
}
